import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { useHistory, useLocation } from "react-router-dom";
import "../../auth.css";

export default function ForgotStart() {
  const history = useHistory();
  const qs = new URLSearchParams(useLocation().search);
  const [email, setEmail] = useState(qs.get("email") || "");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const send = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    setMsg("");
    try {
      await Auth.forgotPassword(email);
      history.replace(`/auth/reset?email=${encodeURIComponent(email)}`);
    } catch (err) {
      setMsg(err.message || "Could not send code.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ph-auth-wrap">
      <div className="ph-auth-card">
        <h1 className="ph-auth-title">Reset Password</h1>

        <form onSubmit={send}>
          <label className="ph-label" htmlFor="fp-email">Enter your email</label>
          <input
            id="fp-email"
            className="ph-field"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
          />

          <button className="ph-button" disabled={!email || busy} type="submit">
            {busy ? "Sending…" : "Send code"}
          </button>
        </form>

        {msg && <p className="ph-error">{msg}</p>}

        <p className="ph-hint">
          <a className="ph-link" href="/signin">Back to Sign In</a>
        </p>
      </div>
    </div>
  );
}
